<template>
    <div class="section-row-justified">
        <span class="section-row-justified__title">
            <slot name="title"></slot>
        </span>

        <span class="section-row-justified__value">
            <slot name="value"></slot>
        </span>
    </div>
</template>

<script>
export default {
    name: 'SectionRowJustified'
};
</script>

<style scoped lang="scss">
.section-row-justified {
    display: flex;
    justify-content: space-between;
    align-items: baseline;
    gap: 1rem;
    flex-wrap: wrap;

    &__title {
        font-weight: 700;
        //margin-right: 1rem; // we have gap for that
        //white-space: nowrap;	// 320px device may not fit
    }
}
</style>
